import { combineReducers } from 'redux'
import navigatorOptions from './navigator_options'
import misc from './misc'

import popupReducerCreator from 'Shared/reducers/popup_reducer_creator'
import PopupTypes from '../popup_types'
const popupStates = popupReducerCreator(PopupTypes)

export default combineReducers({
  popupStates,
  navigatorOptions,
  misc,
})
